import { createFileRoute, Outlet, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/_authenticated")({
  beforeLoad: ({ context }) => {
    if (context.userInfo.state !== "LoggedIn") {
      throw redirect({
        to: "/sign-in",
        search: { redirect: location.pathname },
        replace: true,
      })
    }
  },
  component: () => <Outlet />,
})
